/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Nav_TagInputs */

const en_directory_nav_tag = /** @type {(inputs: Directory_Nav_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tags`)
};

const zh_directory_nav_tag = /** @type {(inputs: Directory_Nav_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标签`)
};

/**
* | output |
* | --- |
* | "Tags" |
*
* @param {Directory_Nav_TagInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_nav_tag = /** @type {((inputs?: Directory_Nav_TagInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Nav_TagInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_nav_tag(inputs)
	return zh_directory_nav_tag(inputs)
});
export { directory_nav_tag as "directory.nav.tag" }